import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileDownloadPath',
})
export class FileDownloadPathPipe implements PipeTransform {
  transform(value: string): unknown {
    return value;
  }
}
